import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import logo from '../images/emoo-high-resolution-logo-transparent.png';

const NavbarContainer = styled(motion.nav)`
  background-color: #ffffff;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
`;

const NavLinks = styled(motion.div)`
  display: flex;
  gap: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    padding: 1rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    transform-origin: top;
  }
`;

const NavLink = styled(motion(Link))`
  color: #1c2f4f;
  text-decoration: none;
  font-weight: 500;
  position: relative;
  padding: 0.25rem 0;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #1c2f4f;
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }

  @media (max-width: 768px) {
    padding: 1rem 0;
  }
`;

const Logo = styled(motion.img)`
  height: 50px;
`;

const HamburgerIcon = styled(motion.div)`
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 6px;

  @media (max-width: 768px) {
    display: flex;
  }

  span {
    height: 2px;
    width: 25px;
    background: #1c2f4f;
    border-radius: 5px;
  }
`;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <NavbarContainer
      animate={{ backgroundColor: scrolled ? '#ffffff' : 'rgba(255, 255, 255, 0.8)' }}
      transition={{ duration: 0.3 }}
    >
      <Link to="/">  {/* Wrap the logo with Link */}
        <Logo
          src={logo}
          alt="Tutoring Service Logo"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        />
      </Link>
      <HamburgerIcon onClick={toggleMenu}>
        <motion.span animate={{ rotate: isOpen ? 45 : 0, y: isOpen ? 8 : 0 }} />
        <motion.span animate={{ opacity: isOpen ? 0 : 1 }} />
        <motion.span animate={{ rotate: isOpen ? -45 : 0, y: isOpen ? -8 : 0 }} />
      </HamburgerIcon>
      <AnimatePresence>
        {(isOpen || window.innerWidth > 768) && (
          <NavLinks
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            <NavLink to="/who-are-we" onClick={() => setIsOpen(false)} whileHover={{ scale: 1.05 }}>Who Are We</NavLink>
            <NavLink to="/faq" onClick={() => setIsOpen(false)} whileHover={{ scale: 1.05 }}>FAQ</NavLink>
            <NavLink to="/meet-the-tutors" onClick={() => setIsOpen(false)} whileHover={{ scale: 1.05 }}>Meet the Tutors</NavLink>
            <NavLink to="/tutor-login" onClick={() => setIsOpen(false)} whileHover={{ scale: 1.05 }}>Tutor Login</NavLink>
          </NavLinks>
        )}
      </AnimatePresence>
    </NavbarContainer>
  );
};

export default Navbar;